import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { AuthWizardContext } from '../../../context/Context';
import { REWARDS_ENABLED } from '../../../helpers/rewardsEnabled';

// HO-TASK-286: el enlace de referido es /register?ref=CODIGO. El código viaja
// con el resto del registro como `referral_code` (SignUpRequest lo acepta
// opcional); si no existe, el backend lo ignora sin bloquear el registro.
const REFERRAL_CODE_PATTERN = /^[A-Z0-9]{4,16}$/;

const getReferralCode = (search) => {
  if (!REWARDS_ENABLED) return null;
  const code = (new URLSearchParams(search).get('ref') || '').trim().toUpperCase();
  return REFERRAL_CODE_PATTERN.test(code) ? code : null;
};

const AuthWizardProvider = ({ children }) => {
  const { search } = useLocation();
  const [user, setUser] = useState(() => {
    const referralCode = getReferralCode(search);
    return referralCode ? { referral_code: referralCode } : {};
  });
  const [step, setStep] = useState(1);

  const handleInputChange = ({ value, name }) => setUser({ ...user, [name]: value });

  const value = { user, setUser, step, setStep, handleInputChange };
  return <AuthWizardContext.Provider value={value}>{children}</AuthWizardContext.Provider>;
}

export default AuthWizardProvider;
